module.exports = __webpack_public_path__ + "img/png1.6bc72109.png";